import React from 'react';
import type { SectionProps } from './types';

export const UnitsSection: React.FC<SectionProps> = ({ data, setFormData }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">Units to Display</label>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={data.units?.showDays !== false}
          onChange={e =>
            setFormData({ ...data, units: { ...data.units, showDays: e.target.checked } })
          }
          className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
        />
        <span className="text-sm text-gray-700">Days</span>
      </label>
      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={data.units?.showHours !== false}
          onChange={e =>
            setFormData({ ...data, units: { ...data.units, showHours: e.target.checked } })
          }
          className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
        />
        <span className="text-sm text-gray-700">Hours</span>
      </label>
      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={data.units?.showMinutes !== false}
          onChange={e =>
            setFormData({ ...data, units: { ...data.units, showMinutes: e.target.checked } })
          }
          className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
        />
        <span className="text-sm text-gray-700">Minutes</span>
      </label>
      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={data.units?.showSeconds !== false}
          onChange={e =>
            setFormData({ ...data, units: { ...data.units, showSeconds: e.target.checked } })
          }
          className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
        />
        <span className="text-sm text-gray-700">Seconds</span>
      </label>
    </div>
  </div>
);
